import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    name: 'GOPT World',
    category: null,
    subcategory: null,
    muscle_code: null,
    enquiry_id: null,
    appointment:false,
}

export const GlobalVariableSlice = createSlice({
    name: 'GlobalVariables',
    initialState,
    reducers: {
        rSetName: (state, action) => {
            state.name = action.payload;
        },
        rSetCategory: (state, action) => {
            state.category = action.payload;
        },
        rSetSubCategory: (state, action) => {
            state.subcategory = action.payload;
        },
        rSetMuscleCode: (state, action) => {
            state.muscle_code = action.payload;
        },
        rSetEnquiryId: (state, action) => {
            state.enquiry_id = action.payload;
        },
        rSetAppointment: (state, action) => {
            state.appointment = action.payload;
        },
    }
});

export const { 
    rSetName, rSetCategory, rSetSubCategory, rSetMuscleCode, rSetEnquiryId,rSetAppointment,
 } = GlobalVariableSlice.actions;

 export default GlobalVariableSlice.reducer;
